export default function popupWindow() {
    $('body').on('click', '.additional-link', function () {
        window.open(this.href, '', 'left=20,top=20,resizable=0');
        return false;
    });
}
